import React from "react";
import { SovosToolbar } from "mosaic-react";
const ToolbarParent = ({
  ToolbarContent,
  ...props
}) => {
  return /*#__PURE__*/React.createElement(SovosToolbar, null, /*#__PURE__*/React.createElement(ToolbarContent, props));
};
export default ToolbarParent;